<template>
<q-expansion-item
    expand-separator
    header-class="text-primary"
>
  <template v-slot:header>
    <q-item-section>
      <div class="row items-center q-gutter-x-lg">
        <h4 class="heading-4">{{ rule.code }} - {{ rule.current_published_version.summary }}</h4>
      </div>
    </q-item-section>
  </template>
  <q-card>
    <q-card-section>
      <template v-if="rule.current_published_version.motivation">
        <div class="row q-mb-md">
          <div class="col-xs-12 col-lg-3 text-weight-bold">
            {{ fieldLabels.motivation }}
          </div>
          <div class="col-xs-12 col-lg-9"
               v-html="rule.current_published_version.motivation" />
        </div>
        <div class="row q-mb-md" v-if="rule.current_published_version.description">
          <div class="col-xs-12 col-lg-3 text-weight-bold">
            {{ fieldLabels.possible_solution }}
          </div>
          <div class="col-xs-12 col-lg-9"
               v-html="rule.current_published_version.description" />
        </div>
      </template>
      <template v-else>
        <div class="row q-mb-md">
          <div class="col-xs-12 col-lg-3 text-weight-bold">
            {{ fieldLabels.description }}
          </div>
          <div class="col-xs-12 col-lg-9"
               v-html="rule.current_published_version.description" />
        </div>
      </template>


      <div class="row q-mb-md">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Fasen
        </div>
        <div class="col-xs-12 col-lg-9">
          {{
            rule.current_published_version.phases.reduce((enumeration, phase) =>
                    `${enumeration ? enumeration + ', ' : ''}${phase.title}`,
                '')
          }}
        </div>
      </div>
      <div class="row q-mb-md">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Categorieën
        </div>
        <div class="col-xs-12 col-lg-9">
          {{
            rule.current_published_version.categories.reduce((enumeration, category) =>
                    `${enumeration ? enumeration + ', ' : ''}${category.title}`,
                '')
          }}
        </div>
      </div>
      <div class="row q-mb-md" v-if="rule.current_published_version.themes.length">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Thema's
        </div>
        <div class="col-xs-12 col-lg-9">
          {{
            rule.current_published_version.themes.reduce((enumeration, theme) =>
                    `${enumeration ? enumeration + ', ' : ''}${theme.title}`,
                '')
          }}
        </div>
      </div>
      <div class="row q-mb-md" v-if="leadingCategory?.content_owner">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Contenteigenaar/eigenaren
        </div>
        <div class="col-xs-12 col-lg-9">
          {{leadingCategory.content_owner}}
        </div>
      </div>


      <div class="row q-mb-md" v-if="rule.current_published_version.links.length">
        <div class="col-xs-12 col-lg-3 text-weight-bold">
          Externe links
        </div>
        <div class="col-xs-12 col-lg-9">
          <ul>
            <li v-for="link in rule.current_published_version.links"
                :key="link.id">
              <common-link
                  target="_blank"
                  :label="link.name || link.href"
                  :href="link.href"
              />
            </li>
          </ul>
        </div>
      </div>

      <div class="row q-mb-md" v-if="rule.current_published_version.assets.length">
        <div class="col-12 text-weight-bold q-mb-md">
          Documenten
        </div>
        <div class="col-12">
          <DocumentList
              :documents="rule.current_published_version.assets" />
        </div>
      </div>
    </q-card-section>
  </q-card>
</q-expansion-item>
</template>

<script>
import DocumentList from '../../../components/lists/DocumentList.vue'
import { config } from '~INSTANCE'

export default {
  components: { DocumentList },
  props: {
    rule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    leadingCategory () {
      if (!this.rule.leading_category_id) {
        return null
      }

      if (!this.rule.current_published_version.categories) {
        return null
      }

      return this.rule.current_published_version.categories.find((category) => {
        return category.id === this.rule.leading_category_id
      })
    },
    fieldLabels () {
      return {
        description: config.translations?.rule?.description ?? 'Omschrijving',
        motivation: config.translations?.rule?.motivation ?? 'Motivatie',
        possible_solution: config.translations?.rule?.possible_solution ?? 'Mogelijke oplossing',
      }
    },
  },
}
</script>
